import { createContext } from 'react';

import type { OnboardingStatus } from '@/core/api';

export interface OnboardingContextValue {
  /** Null until the first answer arrives, and for signed-out visitors. */
  status: OnboardingStatus | null;
  /** True while the first fetch is in flight — the gate must not act on a guess. */
  loading: boolean;
  /** Re-reads status. Called after saving or submitting. */
  refresh: () => Promise<void>;
}

/**
 * Separated from the provider component for the same reason `authContextDef`
 * is: react-refresh only works when a module exports components alone, and a
 * file holding both the context and the provider fails the lint gate.
 */
export const OnboardingContext = createContext<OnboardingContextValue>({
  status: null,
  loading: true,
  refresh: async () => undefined,
});
